export var Cache;
(function (Cache) {
})(Cache || (Cache = {}));
//# sourceMappingURL=Cache.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/cache/core/types/Cache.js
// module id = ./node_modules/@apollo/client/cache/core/types/Cache.js
// module chunks = 53 54